import { LESSON_SCHEDULE_RESERVE_LIMIT } from './lesson-schedule-view';

/** Fallback when a schedule has no program or the program has no numeric reserveLimit. */
export const DEFAULT_SCHEDULE_RESERVE_LIMIT = 999;

export function reserveLimitFromProgram(program: { reserveLimit?: number } | null | undefined): number {
	if (typeof program?.reserveLimit === 'number' && !Number.isNaN(program.reserveLimit)) {
		return program.reserveLimit;
	}
	return DEFAULT_SCHEDULE_RESERVE_LIMIT;
}

/** Capacity for atomic attendance: private lessons are always 1; classes use program limit. */
export function reserveLimitForSchedule(
	schedule: { eventType?: string; reserveLimit?: number },
	program: { reserveLimit?: number } | null | undefined,
): number {
	if (schedule.eventType === 'lesson') {
		return LESSON_SCHEDULE_RESERVE_LIMIT;
	}
	if (schedule.eventType === 'closed') {
		const scheduleLimit = Number(schedule.reserveLimit ?? 0);
		if (Number.isFinite(scheduleLimit) && scheduleLimit > 0) {
			return scheduleLimit;
		}
	}
	return reserveLimitFromProgram(program);
}

/** True when attendance count meets or exceeds the schedule reserve limit. */
export function isScheduleAtCapacity(attendanceCount: number, reserveLimit: number): boolean {
	return attendanceCount >= reserveLimit;
}
